import { Currency } from '@/graphql/generated/types.generated';
import { currencySymbol } from './currency-symbol';
import { round } from './round';

export const monetaryFormat = (value?: number | null, currency?: Pick<Currency, 'symbol'> | null) =>
    currencySymbol(round(value ?? 0, 2), currency, 2);
